const UsageConstants = {
  GET_SUCCESS: 'USAGE_GET_SUCCESS',
  GET_FAIL: 'USAGE_GET_FAIL',
  OPT_IN_SUCCESS: 'USAGE_OPT_IN_SUCCESS',
  OPT_IN_FAIL: 'USAGE_OPT_IN_FAIL',
  OPT_OUT_SUCCESS: 'USAGE_OPT_OUT_SUCCESS',
  OPT_OUT_FAIL: 'USAGE_OPT_OUT_FAIL'
};

export default UsageConstants;